export enum ILocalStorageItems {
  token = 'token',
  user = 'user',
  currentGroup = 'currentGroup',
}
